import React from 'react';
import { useSelector } from 'react-redux';
import { hasSystemAdminRole } from '../../../auth/roles';

function ProtectedRoute({ Component, LoginComponent }) {
  const accessToken = useSelector((state) => state.tokens.accessToken);
  const userRoles = useSelector((state) => state.tokens.userRoles);
  const userRole = useSelector((state) => state.tokens.userRole);

  const isAuthorized = Boolean(accessToken) && hasSystemAdminRole(userRoles, userRole);

  return isAuthorized ? <Component /> : <LoginComponent />;
}

export default ProtectedRoute;
